import React from 'react';
import SocialMediaShareLinks from '../SocialMediaShareLinks/socialMediaShareLinks';
import './header.css';

const Logo = require("../../assets/img/png/logo-strategy.png");

const showPage = () => {
    window.open("https://www.bain.com/consulting-services/digital/digital-transformation/", "_blank");
}

const showDRSPage = () => {
    window.open("https://www.bain.com/consulting-services/digital/radar-360-gps-tool", "_blank");
}

const Header = ({jsonConfig}) => (
    <header className="header">
        <div className="title">
            <img className="logo" alt="logo" src={Logo} onClick={showPage} onKeyUp={showPage} role="presentation"/>
            {/* <img src="img/svg/separator-white.svg"/> */}
            <div className="seperator" />
            <span onClick={showDRSPage} onKeyUp={showDRSPage} role="presentation">Digital Readiness Survey</span>
        </div>
        <div className="links">
            <a className="bain-digital-link" target="_blank" rel="noopener noreferrer" href="https://www.baindigital.com">GO TO BAINDIGITAL.COM</a>
            <SocialMediaShareLinks jsonConfig={jsonConfig} />
        </div>
    </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/header.js